@if (displaySelectableOptions) {
    <div class="mb-3 text-end">
        <button
            class="btn btn-link ps-0 py-0 pe-1"
            (click)="onSelectAllRecipientsChange(true)"
            translate="RECIPIENT_SELECT_ALL"
        ></button>
        <span class="line-separator">|</span>
        <button
            class="btn btn-link pe-0 py-0 ps-1"
            (click)="onSelectAllRecipientsChange(false)"
            translate="RECIPIENT_DESELECT_ALL"
        ></button>
    </div>
}
@if (!cseEmail) {
    <div class="col-10 col-sm-11">
        <p>{{ cseEmail }}</p>
    </div>
}
@for (recipient of model.value; track recipient; let i = $index) {
    @if (!recipient.isHidden) {
        <div class="row mb-3" [formGroup]="recipientForm">
            <div class="col-10 col-sm-11">
                @if (!recipient.isEditable) {
                    <div>{{ recipient.faxEmail.value }}</div>
                }
                @if (recipient.isEditable) {
                    <pace-core-text-input
                        [(model)]="recipient.faxEmail"
                        (valueChange)="updateRecipientStatus(i)"
                        [parentForm]="recipientFormChildren"
                        [ariaLabel]="('RECIPIENT_EMAIL_ARIA_LABEL' | translate) + (i + 1)"
                    ></pace-core-text-input>
                }
                @if (isNgmP58 && isEmailInvalid(recipient)) {
                    <span class="error-text" translate="RECIPIENT_INVALID_EMAIL_ERROR_MESSAGE"> </span>
                }
            </div>
            <div class="col-2 col-sm-1">
                @if (recipient.isDeletable) {
                    <button
                        class="btn btn-warning float-end"
                        (click)="deleteRecipient(i)"
                        [attr.aria-label]="('RECIPIENT_DELETE_EMAIL_ARIA_LABEL' | translate) + (i + 1)"
                    >
                        <fa-icon [icon]="faTrashAlt" class="fa-xs"></fa-icon>
                    </button>
                }
                @if (!recipient.isDeletable) {
                    <pace-core-checkbox-input
                        [(model)]="recipient.isSelected"
                        [parentForm]="recipientFormChildren"
                        (valueChange)="onSelectionChange(recipient)"
                        class="float-end"
                        [ariaLabel]="('RECIPIENT_SELECT_EMAIL_ARIA_LABEL' | translate) + (i + 1)"
                    ></pace-core-checkbox-input>
                }
            </div>
        </div>
    }
}
<div class="row mb-3">
    <div class="col">
        @if (displaySubmitButton) {
            <button
                class="btn btn-primary"
                [disabled]="recipientFormChildren.invalid || disableSubmit"
                (click)="submitToDataManagement()"
                translate="SEND_RECIPIENT_TO_DATA_MANAGEMENT"
            ></button>
        }
    </div>
</div>

<button
    class="btn btn-primary float-end"
    [disabled]="model.value.length >= model.options.maxEntries"
    (click)="addRecipient()"
    translate="RECIPIENT_ADD"
></button>
